import envConfig from '../config/config';
import axios from 'axios';

export const sanitizeQueryObj = (obj) =>
  Object.entries(obj).reduce(
    (newObj, [key, val]) => ({ ...newObj, [key]: val === 'true' ? true : val === 'false' ? false : val }),
    {},
  );

export const updateSubsription = async (queryObj) => {
  try {
    const res = await axios(`${envConfig.apps.providerAccount}/v1/subscriptions`, {
      method: 'POST',
      data: queryObj,
    });
    return res.data;
  } catch (err) {
    console.error(`Error updating subscription`);
    throw err;
  }
};
